export const PLAYER_NAME_MIN_WIDTH = 215;
